import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectAdminAccess } from 'shared/selectors/offersHistory';

import { HideOfferContainerLoadable } from './HideOfferContainerLoadable';

export const HideOfferButton: React.FC = () => {
  const isAdminAccess = useSelector(selectAdminAccess);

  const [openModal, setOpen] = React.useState(false);

  const handleModalOpen = React.useCallback(() => {
    setOpen(true);
  }, [openModal, setOpen]);

  const handleModalClose = React.useCallback(() => {
    setOpen(false);
  }, [openModal, setOpen]);

  if (!isAdminAccess) {
    return null;
  }

  return (
    <>
      <Button size="XS" theme="fill_secondary" onClick={handleModalOpen}>
        Скрыть
      </Button>

      <HideOfferContainerLoadable open={openModal} onClose={handleModalClose} />
    </>
  );
};
